import { apiSlice } from "../../../features/api/apiSlice";

export type UserCategory = {
  id: number;
  name: string;
  is_active: boolean;
};

function pick(res: any) {
  return res?.data?.data ?? res?.data ?? res;
}

function pickArray(res: any) {
  const d = pick(res);
  if (Array.isArray(d)) return d;
  if (Array.isArray(d?.data)) return d.data;
  if (Array.isArray(res?.data)) return res.data;
  return [];
}

export const userCategoriesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUserCategories: builder.query<any, void>({
      query: () => "/user-categories/active",
      transformResponse: (res: any) => pickArray(res),
      providesTags: (result) => {
        const list = Array.isArray(result) ? result : [];
        return list.length
          ? [
              ...list.map((x) => ({
                type: "UserCategories" as const,
                id: x.id,
              })),
              { type: "UserCategories" as const, id: "LIST" },
            ]
          : [{ type: "UserCategories" as const, id: "LIST" }];
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetUserCategoriesQuery } = userCategoriesApi;
